export const required = (value) => (value || typeof value === 'number' ? undefined : 'این فیلد را وارد نمایید');
export const selectRequired = (value) => (value &&value.length>0 ? undefined : 'این فیلد را وارد نمایید');
export const maxLength = (max) => (value) => (value && value.length > max ? `تعداد کاراکتر نباید بیشتر از ${max} باشد` : undefined);
export const maxLength6 = maxLength(6);
export const minLength = (min) => (value) => (value && value.length < min ? `تعداد کاراکتر نباید کمتر از ${min} باشد` : undefined);
export const minLength6 = minLength(6);

export const isLength = (min) => (value) => (value && value.length !== min ? `تعداد کاراکتر باید ${min} باشد` : undefined);
export const isLength6 = isLength(6);
export const number = (value) => (value && !Number.isInteger(Number(value)) ? 'باید یک عدد باشد' : undefined);
export const up0 = (value) => (value && value <= 0 ? 'باید بیشتر از صفر باشد' : undefined);
export const minValue = (min) => (value) => (value && value < min ? `نباید کمتر از ${min} باشد` : undefined);
export const minValue13 = minValue(13);
export const email = (value) => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  ? 'ایمیل نامعتبر است'
  : undefined);
export const isPhone = (value) => (value && !/^(09[0-9][0-9]{8})$/i.test(value) ? 'تلفن وارد شده نامعتبر است' : undefined);
export const isUserName = (value) => (value && !(/^(09[0-9][0-9]{8})$/i.test(value)|| /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) ? 'نام کاربری وارد شده نامعتبر است' : undefined);
export const imageIsRequired = (value) => (!value ? 'عکس مورد نظر را انتخاب کنید' : undefined);
export const validationWrapper = (value,...validations)=>{
  let resualt=undefined;
  validations.some(fn => {
      return resualt=fn(value)});
  return resualt;

}